import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { Formik } from "formik"

import { Submit } from "./Submit"
import FormInput from "components/FormInput"

import SimplePage from "layouts/SimplePage"
import AuthGuard from "./AuthGuard"
import LoginForm from "./LoginForm"

import Form from "./Form"

import "./Contract.sass"
import { useActions } from "store/utils"
import { clearIntent } from "store/app/actions"
import { addContract } from "store/contracts/actions"

const initialValuesStep1 = {
  make: "",
  model: "",
  year: "",
  tip: "",
  vin: "",
  registrska_st: "",
  st_kilometrov: "",
  cena: "",
  selling: true,
}

const initialValuesStep2 = {
  pomanjkljivosti: "",
  oprema: "",
}

const initialValuesProdajalca = {
  ime_prodajalca: "",
  priimek_prodajalca: "",
  emso_prodajalca: "",
  naslov_prodajalca: "",
  postna_st_prodajalca: "",
  drzava_prodajalca: "",
  email_prodajalca: "",
}

const initialValuesKupca = {
  ime_kupca: "",
  priimek_kupca: "",
  emso_kupca: "",
  naslov_kupca: "",
  postna_st_kupca: "",
  drzava_kupca: "",
  email_kupca: "",
}

const initialValuesPerson = (kind) => ({
  [`ime_${kind}`]: "",
  [`priimek_${kind}`]: "",
  [`emso_${kind}`]: "",
  [`naslov_${kind}`]: "",
  [`postna_st_${kind}`]: "",
  [`drzava_${kind}`]: "",
  [`email_${kind}`]: "",
})

const digitRegex = /^[0-9]*$/

function validateStep1VehicleForm(values) {
  const errors = {}

  Object.keys(initialValuesStep1).forEach((key) => {
    if (!values[key]) errors[key] = "Obvezno polje."
  })

  if (!digitRegex.test(values.year)) {
    errors.year = "Leto naj vsebuje samo številke."
  }

  if (!digitRegex.test(values.st_kilometrov)) {
    errors.st_kilometrov = "Vnesite kilometre brez decimalk."
  }

  if (!digitRegex.test(values.cena)) {
    errors.cena = "Cena naj vsebuje samo številke."
  }

  return errors
}

// function validateAgeFromEmso(emso, minAge, maxAge) {
//   let ageValid = true
//   if (minAge != null || maxAge != null) {
//     const dan = parseInt(emso.substring(0, 2)) ?? 0
//     const mesec = parseInt(emso.substring(2, 4)) ?? 0
//     let leto = parseInt(emso.substring(4, 7)) ?? 1970
//     leto = leto < 500 ? leto + 2000 : leto + 1000
//     const age = FormUtil.getAge(new Date(leto, mesec, dan))
//     ageValid = maxAge == null || age <= maxAge
//     ageValid = minAge == null || age >= minAge
//   }
//  return ageValid
// }

function validateEmso(emso, minAge, maxAge) {
  const multipliers = [7, 6, 5, 4, 3, 2, 7, 6, 5, 4, 3, 2, 1]

  if (emso.length !== 13) {
    return false
  }

  let crc = 0

  for (let i = 0; i < emso.length; i++) {
    crc += parseInt(emso[i]) * multipliers[i]
  }

  return crc % 11 === 0
}

function validateStepPersonForm(values, kind) {
  const errors = {}

  Object.keys(initialValuesPerson(kind)).forEach((key) => {
    if (!key.includes("email") && !values[key]) errors[key] = "Obvezno polje."
  })

  const emsoError = "EMŠO ni pravilen."
  if (values.emso_prodajalca && !validateEmso(values.emso_prodajalca)) {
    errors.emso_prodajalca = emsoError
  }
  if (values.emso_kupca && !validateEmso(values.emso_kupca)) {
    errors.emso_kupca = emsoError
  }

  const postalError = "Vnos naj vsebuje samo številke."
  if (
    values.postna_st_prodajalca &&
    !digitRegex.test(values.postna_st_prodajalca)
  ) {
    errors.postna_st_prodajalca = postalError
  }
  if (values.postna_st_kupca && !digitRegex.test(values.postna_st_kupca)) {
    errors.postna_st_kupca = postalError
  }

  return errors
}

function Step1Vozilo({ onSubmit }) {
  const { storedIntent } = useSelector((state) => state.app)

  const { type, payload } = storedIntent || {}

  const values = {}

  if (type === "MAKE_CONTRACT") {
    values.make = payload.make
    values.model = payload.model
    values.year = payload.year
    values.tip = payload.vehicle_category
    values.vin = payload.vin
    values.registrska_st = ""
    values.st_kilometrov = parseInt(payload.km)
    values.cena = ""
    values.selling = true
  }

  const initialValues = { ...initialValuesStep1, ...values }

  return (
    <>
      <div className="Steps">
        <span className="active">
          <span className="number">1</span>{" "}
          <span className="label">Vozilo</span>
        </span>
        <span>
          <span className="number">2</span>{" "}
          <span className="label">Stanje</span>
        </span>
        <span>
          <span className="number">3</span>{" "}
          <span className="label">Prodajalec</span>
        </span>
        <span>
          <span className="number">4</span> <span className="label">Kupec</span>
        </span>
      </div>

      <br />

      <p>
        Prednapolnili smo nam znane podatke o vozilu.
        <br />
        Preverite, če so točni in po potrebi dopolnite manjkajoče.
      </p>

      <br />

      <Formik
        initialValues={initialValues}
        validate={validateStep1VehicleForm}
        onSubmit={onSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
        }) => (
          <Form className="ContractForm Step1Vehicle" onSubmit={handleSubmit}>
            <fieldset
              className={touched.make && errors.make ? "error" : undefined}
            >
              <FormInput
                label="Znamka"
                placeholder="Znamka vozila"
                value={values.make}
                type="text"
                id="make"
                name="make"
                onChange={handleChange}
                onBlur={handleBlur}
                maxLength={32}
              />

              <div className="errors">{touched.make && errors.make}</div>
            </fieldset>

            <fieldset
              className={touched.model && errors.model ? "error" : undefined}
            >
              <FormInput
                label="Model"
                placeholder="Model vozila"
                value={values.model}
                type="text"
                id="model"
                name="model"
                onChange={handleChange}
                onBlur={handleBlur}
                maxLength={32}
              />

              <div className="errors">{touched.model && errors.model}</div>
            </fieldset>

            <fieldset
              className={touched.year && errors.year ? "error" : undefined}
            >
              <FormInput
                label="Leto izdelave"
                placeholder="Leto izdelave vozila"
                value={values.year}
                type="text"
                id="year"
                name="year"
                onChange={handleChange}
                onBlur={handleBlur}
                maxLength={4}
              />

              <div className="errors">{touched.year && errors.year}</div>
            </fieldset>

            <fieldset
              className={touched.tip && errors.tip ? "error" : undefined}
            >
              <FormInput
                label="Tip motorja"
                placeholder="Bencinski, električni, hibridni, ..."
                value={values.tip}
                type="text"
                id="tip"
                name="tip"
                onChange={handleChange}
                onBlur={handleBlur}
                maxLength={32}
              />

              <div className="errors">{touched.tip && errors.tip}</div>
            </fieldset>

            <fieldset
              className={touched.vin && errors.vin ? "error" : undefined}
            >
              <FormInput
                label="Št. karoserije"
                placeholder="Št. karoserije vozila / VIN"
                value={values.vin}
                type="text"
                id="vin"
                name="vin"
                onChange={handleChange}
                onBlur={handleBlur}
                maxLength={17}
              />

              <div className="errors">{touched.vin && errors.vin}</div>
            </fieldset>

            <fieldset
              className={
                touched.registrska_st && errors.registrska_st
                  ? "error"
                  : undefined
              }
            >
              <FormInput
                label="Registrska številka"
                placeholder="Trenutna registrska številka vozila"
                value={values.registrska_st}
                type="text"
                id="registrska_st"
                name="registrska_st"
                onChange={handleChange}
                onBlur={handleBlur}
                maxLength={10}
                autoFocus
              />

              <div className="errors">
                {touched.registrska_st && errors.registrska_st}
              </div>
            </fieldset>

            <fieldset
              className={
                touched.st_kilometrov && errors.st_kilometrov
                  ? "error"
                  : undefined
              }
            >
              <FormInput
                label="Število kilometrov"
                placeholder="Trenutno število prevoženih kilometrov"
                value={values.st_kilometrov}
                type="text"
                id="st_kilometrov"
                name="st_kilometrov"
                onChange={handleChange}
                onBlur={handleBlur}
                maxLength={10}
              />

              <div className="errors">
                {touched.st_kilometrov && errors.st_kilometrov}
              </div>
            </fieldset>

            <fieldset
              className={touched.cena && errors.cena ? "error" : undefined}
            >
              <FormInput
                label="Dogovorjena cena"
                placeholder="Znesek v EUR"
                value={values.cena}
                type="text"
                id="cena"
                name="cena"
                onChange={handleChange}
                onBlur={handleBlur}
                maxLength={32}
              />

              <div className="errors">{touched.cena && errors.cena}</div>
            </fieldset>

            <Submit onClick={handleSubmit}>Naprej</Submit>

            <input type="submit" value="Naprej" style={{ display: "none" }} />
          </Form>
        )}
      </Formik>
    </>
  )
}

function Step2Stanje({ onSubmit }) {
  return (
    <>
      <div className="Steps">
        <span className="done">
          <span className="number">1</span>{" "}
          <span className="label">Vozilo</span>
        </span>
        <span className="active">
          <span className="number">2</span>{" "}
          <span className="label">Stanje</span>
        </span>
        <span>
          <span className="number">3</span>{" "}
          <span className="label">Prodajalec</span>
        </span>
        <span>
          <span className="number">4</span> <span className="label">Kupec</span>
        </span>
      </div>

      <br />

      <Formik initialValues={initialValuesStep2} onSubmit={onSubmit}>
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
        }) => (
          <Form className="ContractForm Step2Stanje" onSubmit={handleSubmit}>
            <p>
              Vozilo se predaja z naslednjimi znanimi pomankljivostmi oziroma
              poškodbami:
            </p>

            <fieldset
              className={
                touched.pomanjkljivosti && errors.pomanjkljivosti
                  ? "error"
                  : undefined
              }
            >
              <FormInput
                placeholder="Seznam pomankljivosti in / ali poškodb"
                value={values.pomanjkljivosti}
                type="text"
                id="pomanjkljivosti"
                name="pomanjkljivosti"
                onChange={handleChange}
                onBlur={handleBlur}
                maxLength={1024}
                isLong
                autoFocus
              />

              <div className="errors">
                {touched.pomanjkljivosti && errors.pomanjkljivosti}
              </div>
            </fieldset>

            <p>Prodajalec kupcu prilaga naslednjo opremo:</p>
            <fieldset
              className={touched.oprema && errors.oprema ? "error" : undefined}
            >
              <FormInput
                placeholder="Seznam opreme"
                value={values.oprema}
                type="text"
                id="oprema"
                name="oprema"
                onChange={handleChange}
                onBlur={handleBlur}
                maxLength={1024}
                isLong
              />

              <div className="errors">{touched.oprema && errors.oprema}</div>
            </fieldset>

            <Submit onClick={handleSubmit}>Naprej</Submit>

            <input type="submit" value="Naprej" style={{ display: "none" }} />
          </Form>
        )}
      </Formik>
    </>
  )
}

function PersonFields({
  kind = "prodajalca",
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
}) {
  return (
    <>
      <fieldset
        className={
          touched[`ime_${kind}`] && errors[`ime_${kind}`] ? "error" : undefined
        }
      >
        <FormInput
          label="Ime"
          placeholder={`Ime ${kind}`}
          value={values[`ime_${kind}`]}
          type="text"
          id={`ime_${kind}`}
          name={`ime_${kind}`}
          onChange={handleChange}
          onBlur={handleBlur}
          maxLength={32}
          autoFocus={!values[`ime_${kind}`]}
        />

        <div className="errors">
          {touched[`ime_${kind}`] && errors[`ime_${kind}`]}
        </div>
      </fieldset>

      <fieldset
        className={
          touched[`priimek_${kind}`] && errors[`priimek_${kind}`]
            ? "error"
            : undefined
        }
      >
        <FormInput
          label="Priimek"
          placeholder={`Priimek ${kind}`}
          value={values[`priimek_${kind}`]}
          type="text"
          id={`priimek_${kind}`}
          name={`priimek_${kind}`}
          onChange={handleChange}
          onBlur={handleBlur}
          maxLength={32}
        />

        <div className="errors">
          {touched[`priimek_${kind}`] && errors[`priimek_${kind}`]}
        </div>
      </fieldset>

      <fieldset
        className={
          touched[`emso_${kind}`] && errors[`emso_${kind}`]
            ? "error"
            : undefined
        }
      >
        <FormInput
          label="EMŠO"
          placeholder={`Enotna matična številka  ${kind}`}
          value={values[`emso_${kind}`]}
          type="text"
          id={`emso_${kind}`}
          name={`emso_${kind}`}
          onChange={handleChange}
          onBlur={handleBlur}
          maxLength={13}
          autoFocus={!!values[`ime_${kind}`]}
        />

        <div className="errors">
          {touched[`emso_${kind}`] && errors[`emso_${kind}`]}
        </div>
      </fieldset>

      <fieldset
        className={
          touched[`naslov_${kind}`] && errors[`naslov_${kind}`]
            ? "error"
            : undefined
        }
      >
        <FormInput
          label="Naslov"
          placeholder={`Ulica stalnega prebivališča ${kind}`}
          value={values[`naslov_${kind}`]}
          type="text"
          id={`naslov_${kind}`}
          name={`naslov_${kind}`}
          onChange={handleChange}
          onBlur={handleBlur}
          maxLength={32}
        />

        <div className="errors">
          {touched[`naslov_${kind}`] && errors[`naslov_${kind}`]}
        </div>
      </fieldset>

      <fieldset
        className={
          touched[`postna_st_${kind}`] && errors[`postna_st_${kind}`]
            ? "error"
            : undefined
        }
      >
        <FormInput
          label="Poštna številka"
          placeholder={`Poštna številka stalnega prebivališča ${kind}`}
          value={values[`postna_st_${kind}`]}
          type="text"
          id={`postna_st_${kind}`}
          name={`postna_st_${kind}`}
          onChange={handleChange}
          onBlur={handleBlur}
          maxLength={6}
        />

        <div className="errors">
          {touched[`postna_st_${kind}`] && errors[`postna_st_${kind}`]}
        </div>
      </fieldset>

      <fieldset
        className={
          touched[`drzava_${kind}`] && errors[`drzava_${kind}`]
            ? "error"
            : undefined
        }
      >
        <FormInput
          label="Država"
          placeholder={`Država ${kind}`}
          value={values[`drzava_${kind}`]}
          type="text"
          id={`drzava_${kind}`}
          name={`drzava_${kind}`}
          onChange={handleChange}
          onBlur={handleBlur}
          maxLength={32}
        />

        <div className="errors">
          {touched[`drzava_${kind}`] && errors[`drzava_${kind}`]}
        </div>
      </fieldset>

      <fieldset
        className={
          touched[`email_${kind}`] && errors[`email_${kind}`]
            ? "error"
            : undefined
        }
      >
        <FormInput
          label="Email"
          placeholder={`Neobvezno polje`}
          value={values[`email_${kind}`]}
          type="text"
          id={`email_${kind}`}
          name={`email_${kind}`}
          onChange={handleChange}
          onBlur={handleBlur}
          maxLength={255}
        />

        <div className="errors">
          {touched[`email_${kind}`] && errors[`email_${kind}`]}
        </div>
      </fieldset>
    </>
  )
}

function Step3Prodajalec({ onSubmit, isProdajalec, setProdajalec }) {
  const { entry: profile } = useSelector((state) => state.profile)

  const userValues = {
    ime_prodajalca: profile.first_name,
    priimek_prodajalca: profile.last_name,
    email_prodajalca: profile.email,
  }

  const initialValues = isProdajalec
    ? { ...initialValuesProdajalca, ...userValues }
    : { ...initialValuesProdajalca }

  return (
    <>
      <div className="Steps">
        <span className="done">
          <span className="number">1</span>{" "}
          <span className="label">Vozilo</span>
        </span>
        <span className="done">
          <span className="number">2</span>{" "}
          <span className="label">Stanje</span>
        </span>
        <span className="active">
          <span className="number">3</span>{" "}
          <span className="label">Prodajalec</span>
        </span>
        <span>
          <span className="number">4</span> <span className="label">Kupec</span>
        </span>
      </div>

      <br />

      <br />

      <Formik
        initialValues={initialValues}
        validate={(values) => validateStepPersonForm(values, "prodajalca")}
        onSubmit={onSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          resetForm,
        }) => (
          <Form
            className="ContractForm Step3Prodajalec"
            onSubmit={handleSubmit}
          >
            {isProdajalec && (
              <p className="in-form-notice">
                Niste prodajalec vozila?{" "}
                <a
                  href="#setProdajalecFalse"
                  onClickCapture={(e) => {
                    setProdajalec(false)
                    resetForm({ values: initialValuesProdajalca })
                  }}
                >
                  Prenesite svoje podatke v polja kupca
                </a>
              </p>
            )}

            <PersonFields
              kind="prodajalca"
              {...{ values, errors, touched, handleChange, handleBlur }}
            />

            <Submit onClick={handleSubmit}>Naprej</Submit>

            <input type="submit" value="Naprej" style={{ display: "none" }} />
          </Form>
        )}
      </Formik>
    </>
  )
}

function Step4Kupec({ onSubmit, isProdajalec }) {
  const { entry: profile } = useSelector((state) => state.profile)

  const userValues = {
    ime_kupca: profile.first_name,
    priimek_kupca: profile.last_name,
    email_kupca: profile.email,
  }

  const initialValues = !isProdajalec
    ? { ...initialValuesKupca, ...userValues }
    : { ...initialValuesKupca }

  return (
    <>
      <div className="Steps">
        <span className="done">
          <span className="number">1</span>{" "}
          <span className="label">Vozilo</span>
        </span>
        <span className="done">
          <span className="number">2</span>{" "}
          <span className="label">Stanje</span>
        </span>
        <span className="done">
          <span className="number">3</span>{" "}
          <span className="label">Prodajalec</span>
        </span>
        <span className="active">
          <span className="number">4</span> <span className="label">Kupec</span>
        </span>
      </div>

      <br />

      <br />

      <Formik
        initialValues={initialValues}
        validate={(values) => validateStepPersonForm(values, "kupca")}
        onSubmit={onSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
        }) => (
          <Form className="ContractForm Step4Kupec" onSubmit={handleSubmit}>
            <PersonFields
              kind="kupca"
              {...{ values, errors, touched, handleChange, handleBlur }}
            />

            <Submit onClick={handleSubmit}>Naprej</Submit>

            <input type="submit" value="Naprej" style={{ display: "none" }} />
          </Form>
        )}
      </Formik>
    </>
  )
}

function ContractWizard() {
  const actions = useActions({
    clearIntent: () => clearIntent(),
    addContract: (values) => addContract(values),
  })

  const [step, setStep] = useState(1)
  const [formData, setFormData] = useState({})
  const [isProdajalec, setProdajalec] = useState(true)

  function handleSubmit(values, oldStep) {
    setFormData({ ...formData, ...values })
    const newStep = oldStep + 1
    setStep(newStep)
    if (newStep === 5) {
      actions.clearIntent()
    }
  }

  useEffect(() => {
    if (step === 5) {
      import("./MakeContract").then(async ({ makeContract }) => {
        makeContract(formData)
        await actions.addContract(formData)
        setStep(6)
      })
    }
  }, [actions, formData, step])

  if (step === 1) {
    return <Step1Vozilo onSubmit={(values) => handleSubmit(values, 1)} />
  }

  if (step === 2) {
    return <Step2Stanje onSubmit={(values) => handleSubmit(values, 2)} />
  }

  if (step === 3) {
    return (
      <Step3Prodajalec
        onSubmit={(values) => handleSubmit(values, 3)}
        isProdajalec={isProdajalec}
        setProdajalec={setProdajalec}
      />
    )
  }

  if (step === 4) {
    return (
      <Step4Kupec
        onSubmit={(values) => handleSubmit(values, 4)}
        isProdajalec={isProdajalec}
      />
    )
  }

  if (step === 5) {
    return <h4>Pripravljam pogodbo...</h4>
  }

  if (step === 6) {
    return (
      <>
        <h4>Pogodba je pripravljena</h4>
        <p>
          Če se avtomatski prenos PDF datoteke še ni pričel, onemogočite zaščito
          pred pop-up okni.
        </p>
      </>
    )
  }
}

export default function Contract() {
  return (
    <AuthGuard placeholder={<LoginRequired />}>
      <SimplePage className="Contract">
        <h1>Kupoprodajna pogodba</h1>
        <ContractWizard />
      </SimplePage>
    </AuthGuard>
  )
}

function LoginRequired() {
  return (
    <SimplePage>
      <h1>Kupoprodajna pogodba</h1>
      <p>
        Uporabite čarovnik za pripravo kupoprodajne pogodbe po meri.
        <br />
        Za dostop do čarovnika morate biti prijavljeni.
      </p>
      <h2 className="Login">Prijava</h2>
      <LoginForm redirect="/moja-garaza/" />
    </SimplePage>
  )
}
